<template>
    <div id="task"
         :class='{"distance":!noResouse}'>
        <div class="fix-up">
            <div id="heasers">
                <div class="header-wrap">
                    <div class="header">
                        <span class="left"
                              @click="goBack"><i class="icon-fanhui"></i></span>
                        <div class="ellipsis">自己选题</div>
                        <slot></slot>
                    </div>
                </div>
            </div>

            <div class="list">
                <!-- 题型: -->
                <transition name="my-slide1"
                            tag="div">
                    <div class="tixing"
                         v-show="tixingShow"
                         :style="`height:${Math.ceil(tixingList.length/2) * 2.45 - 0.1}rem`">
                        <ul class="clearfix">
                            <li @click="choice_qtype(ti.id,index)"
                                v-for="(ti,index) in tixingList">
                                <i :class="{'icon-weixuanzhong':!ti.hendler,'icon-dianji':ti.hendler}"></i>
                                <span>{{ti.name}}</span>
                            </li>
                        </ul>
                    </div>
                </transition>
                <!-- 范围:  -->
                <transition name="my-slide1"
                            tag="div">
                    <div class="tixing"
                         v-show="fanweiShow"
                         :style="`height:${Math.ceil(fanweiList.length/2) * 2.45 - 0.1}rem`">
                        <ul class="clearfix">
                            <li @click="choice_scope(ti.id,index)"
                                v-for="(ti,index) in fanweiList">
                                <i :class="{'icon-weixuanzhong':!ti.hendler,'icon-dianji':ti.hendler}"></i>
                                <span>{{ti.name}}</span>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>
        <template>
            <div class="Space">
                <div v-if='!noResouse'
                     class="qus_choose"
                     v-for="question,index in questions">
                    <div class="question">
                        <i class="dge"
                           v-if='question.published'></i> <!--  发布标识 0 代表没有发过   1 发过 -->
                        <p class="title_t"
                           v-if="question.subject.content||question.subject.image">
                            <span class="title_p"
                                  v-html="question.subject.content"></span>
                            <img :src="question.subject.image"
                                 v-if="question.subject.image" />
                        </p>

                        <div v-for='q,inx in question.asks'>
                            <div v-if='q.display_type == 1'>
                                <!-- 选择题 -->
                                <choice :question='q'
                                        :askLength='question.asks.length'></choice>
                            </div>
                            <div v-if='q.display_type == 2'>
                                <!-- 填空 -->
                                <blanks :question='q'
                                        :askLength='question.asks.length'></blanks>
                            </div>
                            <div v-if='q.display_type == 3'>
                                <!-- 填空 -->
                                <subjective :ask='question.asks'
                                            :index='inx'
                                            :question='q'
                                            :askLength='question.asks.length'></subjective>
                            </div>
                            <div v-if='q.display_type == 4'>
                                <!-- 连线 -->
                                <line-component :ask='q'
                                                :sheet="q.right_answer"
                                                :onlyshow='true'
                                                :askLength='question.asks.length'></line-component>
                            </div>
                        </div>
                    </div>
                    <p class="taskbottom">
                        <span>使用次数: {{question.send_num}}次</span>
                        <span v-if='!question.selected'
                              class="Select"
                              @click='choice_question(question)'>加入</span>
                        <span v-else
                              class="remove"
                              @click='deled_question(question)'>移除</span>
                    </p>
                </div>
            </div>
        </template>
        <template>
            <loadingS v-if='firstLoad'></loadingS>
        </template>
        <template>
            <noResouse v-if='noResouse'></noResouse>
        </template>
        <moreLoading v-show='ismoreLoading'></moreLoading>
        <div class="bottom_btn clearfix">
            <div class="left_btn"><i></i><span>已选（{{numQues}}题）</span></div>
            <div v-if='numQues>0'
                 :class="['right_btn optional_btn',{'able':numQues>0}]"
                 @click='handleOption'>添加</div>
            <div v-else
                 :class="['right_btn',{'disable':numQues==0}]">添加</div>
        </div>
        <!-- 遮罩层 -->
        <transition name="my-fade"
                    tag="div"
                    appear>
            <div class="mask"
                 v-show="tixingShow || nanduShow || laiyuanShow || fanweiShow"
                 @click="mask"></div>
        </transition>
        <div class="masking"
             v-if="prevBoon"
             @click="hidemask"></div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import noResouse from 'COMPONENTS/noResouse.vue';
import moreLoading from 'COMPONENTS/moreLoading.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import choice from 'VIEWS/math/module/choice.vue'  //选择题
import blanks from 'VIEWS/math/module/blanks.vue'  //填空题
import line from 'VIEWS/math/module/line.vue';     //连线题
import subjective from 'VIEWS/math/module/subjective.vue';     //连线题

export default {
    data () {
        return {
            firstLoad: true,
            questions: [],  // 搜索结果
            sources: [],    // 所有来源(练习册)
            qtype: 0,       // 题型
            dtype: 0,       // 难度
            source: 0,      // 当前来源
            scope: 0,       // 范围
            page: 1,        // 当前第几页
            hendler: true,
            tixingShow: false,
            nanduShow: false,
            laiyuanShow: false,
            fanweiShow: false,
            getQuestionTimer: null,
            tixingList: [
                { name: '全部', id: 0, hendler: true },
                { name: '填空题', id: 1 },
                { name: '判断题', id: 2 },
                { name: '选择题', id: 3 },
                { name: '计算题', id: 4 },
                { name: '连一连', id: 5 },
                { name: '看图填空题', id: 6 },
                { name: '改错题', id: 7 },
                { name: '画图题', id: 8 },
                { name: '看图列算式', id: 9 },
                { name: '比较大小', id: 10 },
                { name: '解决问题', id: 11 },
                { name: '动手操作题', id: 12 }
            ],
            fanweiList: [{ name: '全部', id: 0, hendler: true }, { name: '未发布过的试题', id: 1 }],
            titleList: [{ name: '题型', id: 0 }, { name: '范围', id: 3 }],
            titleList2: [{ name: '题型', id: 0 }, { name: '来源', id: 2 }, { name: '范围', id: 3 }],
            prevBoon: false,
            titles: '自己选题',
            sid: this.$route.params.sid,
            type: this.$route.params.type,  // 2同步习题 3单元复习
            searchlist: [], //
            noResouse: false,
            numQues: 0,  //计算发布试题数
            isPost: true,
            ismoreLoading: false,
        }
    },
    components: {
        headers,
        choice,
        blanks,
        'line-component': line,
        loadingS,
        noResouse,
        subjective,
        moreLoading,
    },
    computed: {},
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    watch: {},
    methods: {
        hidemask () {
            // 隐藏遮罩
            this.prevBoon = false;
        },
        back () {
            this.$router.go(-1);
            this.clearTask();
        },
        clearTask () {
            // 清除vuex  存的值
            let mathTask = this.$store.state.MathTask.mathTask;
            for (let item in mathTask) {
                let _o = {
                    'id': item,
                    'askLength': mathTask[item].length
                };
                this.$store.commit('removeMathTask', _o);
            }
        },
        setTixing (id, i) {
            this.isPost = true
            // 题型  范围 选择

            if (!this.titleList[i].hendler) {
                this.titleList.forEach(ti => {
                    ti.hendler = false;
                })
                if (id == 0) {
                    this.tixingShow = true;
                    this.fanweiShow = false;
                } else if (id == 1 || id == 2) {
                    this.tixingShow = false;
                    this.fanweiShow = false;
                } else {
                    this.tixingShow = false;
                    this.fanweiShow = true;
                }
            } else {
                this.tixingShow = false;
                this.fanweiShow = false;
            }
            this.titleList[i].hendler = !this.titleList[i].hendler;
            this.titleList.splice(i, 1, this.titleList[i]);
        },
        mask () {
            this.titleList.forEach(ti => {
                ti.hendler = false;
            })
            this.titleList2.forEach(ti => {
                ti.hendler = false;
            })
            this.tixingShow = false;
            this.nanduShow = false;
            this.fanweiShow = false;
        },
        clearlist () {
            this.questions = [];
        },
        choice_qtype (qtype, i) {
            window.scrollTo(0, 0);  //回到顶部
            // 题型范围选择
            this.qtype = qtype;
            this.page = 1;
            this.tixingList.forEach(d => {
                d.hendler = false;
            })
            this.tixingList[i].hendler = true;
            this.tixingList.splice(i, 1, this.tixingList[i]);
            this.clearlist();
            this.search();
            this.mask();
            this.firstLoad = true;
        },
        choice_question (question) {
            // 添加试题试题
            // if ((this.numQues + question.asks.length) > 30) {
            //   layer.tips('已经超出30道题，不能再添加试题了')
            //   return false
            // }
            if (this.sid == 21) {
                if ((this.numQues + question.asks.length) > 100) {
                    layer.tips('已经超出100道题，不能再添加试题了')
                    return false
                }
            } else if (this.sid == 22) {
                if ((this.numQues + question.asks.length) > 50) {
                    layer.tips('已经超出50道题，不能再添加试题了')
                    return false
                }
            }
            this.numQues += question.asks.length
            question.selected = !question.selected
            let obj = {}
            obj.id = question.id

            this.$store.commit('setQuestion', obj)
        },
        deled_question (question) {
            if (this.numQues > 0) {
                this.numQues -= question.asks.length
                // 移除试题试题
                question.selected = !question.selected
                let obj = {}
                obj.id = question.id
                this.$store.commit('delQuestion', obj)
            }
        },
        choice_scope (scope, i) {
            window.scrollTo(0, 0);
            // 范围选择试题
            this.scope = scope;
            this.page = 1;
            this.fanweiList.forEach(d => {
                d.hendler = false;
            })
            this.fanweiList[i].hendler = true;
            this.fanweiList.splice(i, 1, this.fanweiList[i]);
            this.clearlist();
            this.search();
            this.mask();
            this.firstLoad = true;
        },

        submit () {//跳转发布
            let details = []
            //this.searchlist  来自search接口
            //this.$store.state.math.question  来自questions接口
            //id 跟search接口id 是一一对应  需要search 接口cid 拼接
            this.searchlist.forEach((m, n) => {
                this.$store.state.math.question.forEach((l, i) => {
                    if (l.id == m.id) {
                        let obj = {}
                        obj.qid = l.id
                        obj.cid = m.cid
                        details.push(obj)
                    }
                })
            })
            this.$store.commit('setreleaseid', details)
            this.$router.push('/sx/release/' + this.sid + '/' + this.type)
        },
        setShow (ask) {
            let tempclose = !ask.close;
            this.$set(ask, "close", tempclose);
            this.questions.forEach(val => {
                val.asks.forEach(askobj => {
                    if (askobj !== ask) {
                        this.$set(askobj, "close", false);
                    }
                });
            })
        },

        search () {
            (async () => {
                this.noResouse = false
                let qids_s;
                let qmap;
                let cid = this.$store.state.math.chapterid.join(',');
                let that = this
                this.isPost = true
                if (this.isPost) {
                    this.isPost = false
                    await this.$http.post(API_URL_TASK_API + '/maths/send/general/question/search', {
                        special_flag: 1,   // 本次要传special_flag=1
                        //book_id: 1636,
                        book_id: localStorage.getItem('book_id'),
                        cids: localStorage.getItem('qid'), //章节id
                        //cids: '34554,34555', //章节id
                        qtype: 0,  //题型
                        scope: 0,  //范围(0全部1未发过)
                        p: this.page,         //页号
                        sid: this.sid,              //学科
                        // review_user: 1
                        //display: 1,//保证新题型，不含解答题
                        filter_qids: JSON.parse(localStorage.getItem('filter_qids')).join(','),
                    }).then((res) => {
                        if (res.data.response === 'ok') {
                            this.isPost = true;
                            this.ismoreLoading = false;
                            if (res.data.data.length) {
                                that.searchlist = [...that.searchlist, ...res.data.data];
                                // 数组里面的对象去重
                                var hash = {};
                                that.searchlist = that.searchlist.reduce((item, next) => {
                                    hash[next.id] ? '' : hash[next.id] = true && item.push(next);
                                    return item
                                }, [])
                                // //console.log(that.searchlist)
                                let qlist = res.data.data;
                                qmap = new Map();
                                qlist.forEach((q) => qmap.set(q.id, q));
                                let qids = qlist.map(q => q.id);
                                qids_s = qids.join(',');
                            } else if (!res.data.data.length && this.page != 1) {
                                // this.noResouse = true
                                this.isPost = false
                                this.firstLoad = false
                                this.isPost = false
                                layer.tips('已加载全部内容')
                            } else {
                                this.isPost = false
                                this.noResouse = true
                                this.firstLoad = false
                            }
                        } else {
                            this.noResouse = true
                        }
                    });
                    // this.isPost = false
                    if (qids_s) {
                        await this.$http.post(API_URL_TASK_API + '/maths/questions', {
                            qid: qids_s,
                            sid: this.sid,
                            preview: 1   //填空题 1填 0不填
                        }).then((res) => {
                            if (res.data.response === 'ok') {
                                this.isPost = true
                                this.firstLoad = false;
                                let questions = "";
                                this.ismoreLoading = false;
                                if (!res.data.data.length && this.page != 1) {
                                    this.page = 0;
                                    layer.tips('已加载全部内容');
                                    return false;
                                } else if (!res.data.data.length) {
                                    this.noResouse = true
                                } else {
                                    this.noResouse = false
                                    questions = res.data.data;
                                    // 添加扩展属性(cid, text_cid, published)
                                    questions.forEach((q) => q.ext = qmap.get(q.id));
                                    //每次加载数组看是否选中
                                    questions.forEach(q => {
                                        // //console.log(q.id)
                                        if (this.$store.state.math.qid.indexOf(q.id) > -1) {
                                            q.selected = true;
                                        } else {
                                            q.selected = false;
                                        }
                                    })
                                }
                                this.questions = [...this.questions, ...questions];
                                if (localStorage.getItem('activeIds')) {
                                    this.questions.forEach(e => {
                                        JSON.parse(localStorage.getItem('activeIds')).forEach(j => {
                                            if (j === e.id) {
                                                e.selected = true;
                                            }
                                        })
                                    })
                                }

                            }
                            this.$nextTick(function () {
                                MathJax.Hub.Typeset(document.body)
                            })
                        })
                    }
                }
            })();
        },
        getQuestion () {//下拉加载
            let that = this;
            this.getQuestionTimer && clearTimeout(this.getQuestionTimer);
            this.getQuestionTimer = setTimeout(function () {
                let docHeight = document.body.scrollHeight;
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                let winHeight = window.screen.availHeight;
                if (winHeight + scrollTop >= docHeight - 20 && that.isPost) {
                    that.page++;
                    that.ismoreLoading = true;
                    that.search();
                }
            }, 500)
        },
        /**添加自选 */
        handleOption () {
            let activeData = []
            this.questions.forEach(e => {
                if (e.selected) {
                    activeData.push(e)
                }
            })
            localStorage.setItem('activeData', JSON.stringify(activeData))
            this.$router.replace('/sx/testPaper/preview/' + this.sid + '/' + this.type + '?typeOf=' + this.$route.query.typeOf)
        },
        goBack () {
            this.$router.replace('/sx/testPaper/preview/21/1?typeOf=1')
        }
    },
    created () {
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.$store.state.math.question = []  //初始化值
        this.search();
        window.addEventListener('scroll', this.getQuestion, true)

        if (JSON.parse(localStorage.getItem('activeIds'))) {
            let activeData = JSON.parse(localStorage.getItem('activeData'))
            JSON.parse(localStorage.getItem('activeIds')).forEach(j => {
                activeData.forEach(e => {
                    if (e.id == j) {
                        console.log(e)
                        this.numQues += e.asks.length
                    }
                })

            })

        }
    },
    destroyed () {
        this.$store.state.math.qid = []  //销毁所有选中的id
        window.removeEventListener('scroll', this.getQuestion, true)

    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#task {
    min-height: 100%;
    overflow: auto;
    position: relative;
}

.distance {
    padding-bottom: 120px / $ppr;
}

.icon-zhankaixia,
.icon-shang {
    display: inline-block;
    margin-left: 20px / $ppr;
    width: 20px / $ppr;
    height: 20px / $ppr;
}

.icon-zhankaixia {
    background: url("./img/icon_open.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-shang {
    background: url("./img/icon_close.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-weixuanzhong,
.icon-dianji {
    display: inline-block;
    width: 40px / $ppr;
    height: 40px / $ppr;
}

.icon-weixuanzhong {
    background: url("./img/icon_unchecked.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-dianji {
    background: url("./img/circle.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.fix-up {
    z-index: 20;
}

.title {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 8;
    background: $c-fbg;
    padding: $w 0;
    border-bottom: 1px / $ppr solid $line;
    // -webkit-box-shadow:0px -1px 2px 0px;
    // box-shadow: 0px -1px 2px 0px;
    span {
        display: block;
        float: left;
        line-height: 46px / $ppr;
        width: 50%;
        text-align: center;
        box-sizing: border-box;
        border-right: 1px / $ppr solid $line;
        i {
            padding-left: 10px / $ppr;
            color: $c-tag;
        }
        &.active {
            color: #5e89ef;
        }
    }
    span:last-child {
        border-right: none;
    }
}

.list {
    position: fixed;
    left: 0;
    right: 0;
    top: 190px / $ppr;
    z-index: 100;
    ul {
        position: relative;
        z-index: 10;
        background: $c-fbg;
        // border-top: 1px/$ppr solid red;
        li {
            float: left;
            width: 50%;
            line-height: $h-header;
            height: $h-header;
            box-sizing: border-box;
            display: flex;
            display: -webkit-flex;
            display: -webkit-box;
            align-items: center;
            -webkit-align-items: center;
            i {
                margin-left: 40px / $ppr;
                position: relative;
                top: 10px / $ppr;
                padding-right: 10px / $ppr;
            }
            .icon-dianji {
                color: $c-tag;
            }
        }
    }
}

.mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: $mask;
    z-index: 6;
    transition: background-color 0.3s linear;
}

.title_t {
    background: $c-fbg;
    padding: $w;
    line-height: 48px / $ppr;
    border-bottom: $line 1px / $ppr solid;
}

.qus_choose {
    background: $c-fbg;
    margin-bottom: 30px / $ppr;
    .question {
        position: relative;
        .dge {
            width: 100px / $ppr;
            height: 56px / $ppr;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            background: url("./img/icon_to.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }
    ul {
        li {
            padding: $w;
            line-height: 48px / $ppr;
            border-bottom: $line 1px / $ppr solid;
            position: relative;
            i {
                position: absolute;
                top: $w;
                left: $w;
                text-align: center;
                display: inline-block;
                width: 50px / $ppr;
                height: 50px / $ppr;
                line-height: 50px / $ppr;
                border-radius: 50%;
                &.i_equal {
                    border: #66cc22 1px / $ppr solid;
                    background: #66cc22;
                    color: #fff;
                }
                &.i_noequal {
                    border: $line 1px / $ppr solid;
                }
            }
            p {
                display: inline-block;
                width: 580px / $ppr;
                padding-left: 80px / $ppr;
                &.p_equal {
                    color: #66cc22;
                }
            }
        }
    }
    .cankao {
        color: $c-tag;
    }
    .p {
        padding: $w;
        line-height: 48px / $ppr;
        border-bottom: $line 1px / $ppr solid;
        min-height: 48px / $ppr;
    }
    position: relative;
    .taskbottom {
        line-height: 96px / $ppr;
        height: 96px / $ppr;
        padding: 0 $w;
        font-size: $lt;
        color: $c-light;
        position: relative;
        span:nth-of-type(2) {
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            line-height: 50px / $ppr;
            text-align: center;
            width: 122px / $ppr;
            height: 48px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}

.has {
    display: inline-block;
    padding: 0 15px / $ppr 0 $w;
    height: 56px / $ppr;
    line-height: 56px / $ppr;
    background-color: rgba(42, 202, 148, 0.9);
    border-bottom-left-radius: 28px / $ppr;
    border-top-left-radius: 28px / $ppr;
    font-size: $md;
    color: $c-header;
    position: absolute;
    top: $w;
    right: 0;
}

.bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    line-height: $h-header;
    height: $h-header;
    text-align: center;
    background: $line;
}

.choice {
    background: $c-theme;
    color: $c-header;
}

.masking {
    width: 100vw;
    height: 100vh;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #000;
    opacity: 0.6;
    z-index: 10;
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 70%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 30%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
    .optional_btn {
        color: #fff;
        background: #5e89ef;
    }
}
.my-fade-enter,
.my-fade-leave-to {
    background-color: rgba(0, 0, 0, 0);
}
.tixing,
.fanwei {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide1-enter,
.my-slide1-leave-to,
.my-slide2-enter,
.my-slide2-leave-to {
    height: 0 !important;
}
.header-wrap .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;
    .icon-fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    .ellipsis {
        width: 520px / $ppr;
        margin: 0 auto;
    }
}
</style>
